import React, { useState, useEffect} from 'react';
import { useSearchParams } from 'react-router-dom';
import language from '../../../utils/LanguageSettings';
import { fetchSupport, fetchSupportItems, fetchSupportSearchResult } from '../../functions/fetchSupport';
import '../../../css/support.css'
import translations from '../../../text/get-started-translations.json';
import ReactPaginate from 'react-paginate';
import RenderSnA from '../../functions/renderSnA';

interface SupportFrequentlyReadArticlesProps {

}

const SupportFrequentlyReadArticles: React.FC<SupportFrequentlyReadArticlesProps> = () => {
    const [searchParams] = useSearchParams();
    const pageTranslations = translations[language];
    const [loading, setLoading] = useState<boolean>(true);
    const [targetItems, setTargetItems] = useState<any>(null);
    const [itemOffset, setItemOffset] = useState(0);
    const itemsPerPage = 8;
    const endOffset = itemOffset + itemsPerPage;
    const [currentItems, setCurrentItems] = useState<any>(null);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [loadingStyle, setLoadingStyle] = useState<string>("none");
    const [supportData, setSupportData] = useState<any>();
    const [seo, setSeo] = useState<any>(null);
    const [ga, setGa] = useState<any>(null);

    const cat = searchParams.get('cat');
    const keyword = searchParams.get('keyword');

    useEffect(() => {
        const fetchData = async () => {
            let data = null;
            if(keyword){
                data = await fetchSupportSearchResult(language,keyword);
                if(data){
                    setTargetItems(filterData(data));
                }
            }else{
                data = await fetchSupportItems(language);
                if(data?.data){
                    setTargetItems(filterData(data?.data));
                }
            }
            let supportData = await fetchSupport(language);
            if(supportData){
                setSupportData(supportData?.data?.attributes);
                setGa(supportData?.data?.attributes?.GA || null);
                setSeo(supportData?.data?.attributes?.SEO || null);
                setLoading(false);
            }
        };
        fetchData();
    }, [language]);

    useEffect(() => {
        setCurrentItems(targetItems?.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(targetItems?.length / itemsPerPage));
    },[targetItems])

    useEffect(() => {
        setCurrentItems(targetItems?.slice(itemOffset, endOffset));     
    },[itemOffset])

    const filterData = (datas: any) => {
       return datas?.filter((data: { attributes: { Categories: { toString: () => string | any[]; }; }; category: any; "": any; }) => {
            if (!cat || !pageTranslations[cat.toLocaleLowerCase()]){
                return true;
            }
            if(!keyword){
                if (!data?.attributes || !data?.attributes?.Categories) {
                    return false;
                }
                return data?.attributes?.Categories.toString().indexOf(pageTranslations[cat?.toLocaleLowerCase()]) > -1;
            }else{
                if (!data || !data?.category) {
                    return false;
                }
                return data?.category.toString().indexOf(pageTranslations[cat?.toLocaleLowerCase()]) > -1;
            }
        });
    }

    const handleData = (datas: any) => {
        return Array.isArray(datas) && datas.map((item, index) => (
            <div key={index}>
                <hr className="my-3 thin-light" />
                <a href= {window.location.origin +"/support/" + (keyword ? item?.slug : item?.attributes?.slug)} className="with-arrow p-relative d-block w-100 py-3 pr-4">
                    <h5 className="font-medium">{keyword ? (language == "en" ? item.nameEn : item.nameZh) : item?.attributes?.Name}</h5>
                </a>
            </div>
        ))
    }

    const handlePageClick = (event: { selected: number }) => {
        setLoadingStyle("block");
        setTimeout(()=>{
            const selectedPage = event.selected;
            const newOffset = selectedPage * itemsPerPage;
            setItemOffset(newOffset);
            setCurrentPage(selectedPage);
            setLoadingStyle("none");
        },500);
    };

    if (loading) {
        return (
        <>
            <div id="loader">
                <div className="spinner-border"></div>
            </div>
        </>
        );
    }
    
    return (
      <>
        <RenderSnA seo={seo} ga={ga} />
        <main id="main" className='support-frequently' role="main">
            <section className="spacer support">
                <div className="container-fluid">
                    <h1 className="text-center mb-4 font-medium text-center">{supportData?.frequently_read_articles_section_title}</h1>
                    <h2 className="text-center color-1 font-medium mb-5">{pageTranslations[cat?.toLocaleLowerCase()]}</h2>
                    <div className="results-area">
                        <div id="loader" style={{display:loadingStyle}}><div className="spinner-border"></div></div>
                        {handleData(currentItems)}
                        <ReactPaginate
                            breakLabel="..."
                            nextLabel={currentPage < pageCount - 1 ? <i className="support-icon icon-now-arrow-right"></i> : null}
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={3}
                            pageCount={pageCount}
                            previousLabel={currentPage > 0 ? <i className="support-icon icon-now-arrow-left"></i> : null}
                            renderOnZeroPageCount={null}
                            containerClassName="support-pagination"
                            pageClassName="support-page-item"
                            pageLinkClassName="support-page-link"
                            activeClassName="active"
                            previousClassName="support-page-item"
                            nextClassName="support-page-item"
                            previousLinkClassName="support-page-link"
                            nextLinkClassName="support-page-link"
                            disabledClassName="disabled"
                            forcePage={currentPage}
                        />
                    </div>
                </div>
            </section>
        </main>
      </>
    );
};

export default SupportFrequentlyReadArticles;